(() => {
  'use strict';
  function initialize(root = document) {
    root.querySelectorAll('[data-union-newsletter-popup]').forEach(dialog => {
      if (dialog.dataset.initialized === 'true') return;
      dialog.dataset.initialized = 'true';
      const designMode = dialog.dataset.designMode === 'true';
      const storageKey = 'union-newsletter-dismissed-until-v1';
      const subscribedKey = 'union-newsletter-subscribed-v1';
      const result = dialog.querySelector('[data-newsletter-result]')?.dataset.newsletterResult;
      let suppressed = false;
      try { suppressed = localStorage.getItem(subscribedKey) === 'true' || Number(localStorage.getItem(storageKey)) > Date.now(); } catch {}
      let timer;
      let observer;
      let scheduled = false;
      let displayed = false;
      let returnFocus;
      function syncLanguage(event) {
        const language = event?.detail?.language || window.UnionLanguage?.language || (document.documentElement.lang === 'es' ? 'es' : 'en');
        dialog.lang = language;
        dialog.querySelectorAll('[data-union-copy]').forEach(el => { el.textContent = el.dataset[language] || el.dataset.en; });
        dialog.querySelector('[data-newsletter-close]').setAttribute('aria-label',language === 'es' ? 'Cerrar' : 'Close');
      }
      const blocked = () => document.documentElement.classList.contains('grand-age-locked') || document.querySelector('dialog[open]:not([data-union-newsletter-popup])') || document.querySelector('cart-drawer dialog[open]') || document.visibilityState === 'hidden';
      function open() {
        if (blocked() || displayed || typeof dialog.showModal !== 'function') return;
        syncLanguage();
        returnFocus = document.activeElement;
        dialog.showModal();
        displayed = true;
        observer?.disconnect();
      }
      function schedule() {
        if ((suppressed && !result) || scheduled || displayed || blocked()) return;
        scheduled = true;
        timer = window.setTimeout(() => { scheduled = false; open(); }, result ? 0 : Number(dialog.dataset.delay || 15) * 1000);
      }
      function remember() {
        if (designMode) return;
        try {
          if (result === 'success') localStorage.setItem(subscribedKey,'true');
          else localStorage.setItem(storageKey,String(Date.now() + Number(dialog.dataset.repeatDays || 7) * 86400000));
        } catch {}
      }
      function close() { dialog.close(); }
      dialog.querySelector('[data-newsletter-close]').addEventListener('click',close);
      dialog.querySelector('[data-newsletter-shop]').addEventListener('click',close);
      dialog.addEventListener('click',event => {
        if (event.target !== dialog) return;
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) close();
      });
      dialog.addEventListener('close',()=>{ remember(); returnFocus?.focus?.({preventScroll:true}); });
      document.addEventListener('union:languagechange',syncLanguage);
      syncLanguage();
      if (result === 'success') remember();
      if (designMode) {
        document.addEventListener('shopify:section:select',event=>{if(event.target.contains(dialog)){displayed=false;open();}});
        document.addEventListener('shopify:section:deselect',event=>{if(event.target.contains(dialog)&&dialog.open)close();});
        return;
      }
      if (suppressed && !result) return;
      observer = new MutationObserver(schedule);
      observer.observe(document.documentElement,{subtree:true,attributes:true,attributeFilter:['open','class']});
      document.addEventListener('visibilitychange',schedule);
      window.addEventListener('pagehide',()=>{clearTimeout(timer);observer.disconnect();},{once:true});
      schedule();
    });
  }
  if(document.readyState === 'loading')document.addEventListener('DOMContentLoaded',()=>initialize(),{once:true});
  else initialize();
  document.addEventListener('shopify:section:load',event=>initialize(event.target));
})();
